import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { drawerItemsMain } from "./ProductTrackerDrawerItemsMain ";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import ItemTrackerScreen from "../../../screens/ItemTracker/ItemTrackerScreen";
import ItemTrackerDashboard from "../../../screens/ItemTracker/Dashboard/ItemTrackerDashboard";
import ProductTrackerDetailsReport from "../../../screens/ItemTracker/ProductTrackerDetailsReport";
import ChinaTrackerScreen from "../../../screens/ChinaTracker/ChinaTrackerScreen";
import { userClaimInformation } from "../../../models/usersModel";
import { useSelector } from "react-redux";
import teamsConfig from "../../../utils/constants/teams";
import roles from "../../../utils/constants/roles";
import { useTranslation } from "../../../utils/useTranslation";
import ChinaTrackerDetailsReport from "../../../screens/ChinaTracker/partials/ChinaTrackerDetailsReport";
import { View } from "../../../components/shared/Themed";
import Spinner from "../../../components/shared/Spinner";
import ChinaShipmentScreen from "../../../screens/ChinaShipment/ChinaShipmentScreen";
import ChinaShipmentDetailsReport from "../../../screens/ChinaShipment/partials/ChinaShipmentDetailsReport";

const Drawer = createDrawerNavigator();

export default function ProductTrackerDrawerNavigator() {
  const [userProfile, setUserProfile] = React.useState<userClaimInformation>();
  const { userInfo, currentRole } = useSelector(
    (state: any) => state.configurations,
  );
  const { t } = useTranslation();
  const dimensions = useWindowDimensions();
  const { purchasing, sales, operation } = teamsConfig.teams;
  const { owner, admin } = roles.roles;
  const [isPurchasingTeam, setIsPurchasingTeam] = React.useState(false);

  React.useEffect(() => {
    if (userInfo) {
      setUserProfile(userInfo);
    }
  }, [userInfo]);

  React.useEffect(() => {
    if (
      userProfile?.team?.toUpperCase() === purchasing ||
      currentRole?.includes(owner) ||
      currentRole?.includes(admin)
    ) {
      setIsPurchasingTeam(true);
    } else {
      setIsPurchasingTeam(false);
    }
  }, [userProfile, currentRole]);

  const filteredDrawerItems = React.useMemo(() => {
    const updatedItems = drawerItemsMain.filter((item: any) => {
      if (item.key === "ChinaTracker") {
        return isPurchasingTeam;
      }
      return true;
    });

    return updatedItems.map((item: any) => {
      let translatedTitle = item.title;
      let translatedRoutes = [...item.routes];

      if (item.key === "ProductTracker") {
        translatedTitle = t("customerOrderTracker");
        translatedRoutes[0].title = t("customerOrderTracker");
      } else if (item.key === "TrackerDashboard") {
        translatedTitle = t("trackerDashboard");
        translatedRoutes[0].title = t("trackerDashboard");
      } else if (item.key === "ChinaTracker") {
        translatedTitle = t("chinaOrderTracker");
        translatedRoutes[0].title = t("chinaOrderTracker");
      } else if (item.key === "ChinaShipment") {
        translatedTitle = t("chinaShipment");
        translatedRoutes[0].title = t("chinaShipment");
      }

      return {
        ...item,
        title: translatedTitle,
        routes: translatedRoutes,
      };
    });
  }, [isPurchasingTeam, t]);

  if (!userProfile || !currentRole) {
    return (
      <View
        style={{
          flexDirection: "column",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner
          size="small"
          color="#74BBFF"
          styles={{
            flexDirection: "row",
            justifySelf: "center",
            alignSelf: "center",
          }}
        />
      </View>
    );
  }

  return (
    <Drawer.Navigator
      screenOptions={{
        drawerStyle: {
          width: 200,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front",
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={filteredDrawerItems} {...props} />
      )}
    >
      <Drawer.Screen
        options={{
          drawerLabel: "ProductTracker",
          title: t("customerOrderTracker"),
        }}
        name="ProductTrackerReport"
        component={ItemTrackerScreen}
      />
      {isPurchasingTeam && (
        <Drawer.Screen
          options={{
            drawerLabel: "TrackerDashboard",
            title: t("trackerDashboard"),
          }}
          name="TrackerDashboardReport"
          component={ItemTrackerDashboard}
        />
      )}
      <Drawer.Screen
        options={{
          drawerLabel: "ProductTrackerDetailsReport",
          title: t("customerOrderTracker"),
        }}
        name="ProductTrackerDetailsReport"
        component={ProductTrackerDetailsReport}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaTrackerDetailsReport",
          title: t("chinaOrderTracker"),
        }}
        name="ChinaTrackerDetailsReport"
        component={ChinaTrackerDetailsReport}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaTracker",
          title: t("chinaOrderTracker"),
        }}
        name="ChinaTrackerReport"
        component={ChinaTrackerScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaShipment",
          title: t("chinaShipment"),
        }}
        name="ChinaShipmentReport"
        component={ChinaShipmentScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaShipmentDetailsReport",
          title: t("chinaShipmentDetailsReport"),
        }}
        name="ChinaShipmentDetailsReport"
        component={ChinaShipmentDetailsReport}
      />
    </Drawer.Navigator>
  );
}
